import { render, staticRenderFns } from "./HsabImportedClaimColumnSortIcon.vue?vue&type=template&id=686e6e74&scoped=true"
import script from "./HsabImportedClaimColumnSortIcon.vue?vue&type=script&lang=ts"
export * from "./HsabImportedClaimColumnSortIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e6e74",
  null
  
)

export default component.exports